import useOrderList from 'hooks/account/lists/useOrderList'
import * as React from 'react'
import styled from 'styled-components'
import DyProductSlider from 'theme/molecules/DyProductSlider'
import ProductSlider from 'theme/molecules/ProductSlider'
import fetchBySw6Uuid from 'utils/productListFetcher/bySwUuid'
import withTranslations from '../withTranslations'
import useTranslations from 'hooks/useTranslations'

export function LastOrderedProducts() {
  const orderList = useOrderList({ pageSize: 10 })
  const t = useTranslations<'account-Dashboard'>()
  const productList = React.useMemo(() => {
    const orders = orderList.data || []
    const list = new Set<string>()
    for (const row of orders)
      for (const item of row.lineItems) list.add(item.sw6Uuid)

    return Array.from(list)
  }, [orderList.data])

  if (!orderList.setup)
    return (
      <Wrapper className="LastOrderedProducts">
        <div
          style={{ height: 420 }}
          data-cy-state="loading-last-ordered-products"
        />
      </Wrapper>
    )

  if (productList.length === 0)
    return (
      <Wrapper
        className="LastOrderedProducts"
        data-cy-state="show-favourite-products"
      >
        <DyProductSlider
          dySelector="wdv-1834-myaccount-recommendation-slot1"
          gridArea="Account-Favourite"
          title={t('lastorderedproducts_favorite_products')}
        />
      </Wrapper>
    )

  return (
    <Wrapper
      className="LastOrderedProducts"
      data-cy-state="show-last-ordered-products"
    >
      <ProductSlider
        title={t('lastorderedproducts_ordered_products')}
        fetchFn={fetchBySw6Uuid({
          sw6Uuids: productList,
          maxHits: 20,
          keepSorting: true,
          noDistinct: true
        })}
        maxProducts={productList.length < 60 ? productList.length : 60}
        listname={'pdpCrosssell'}
      />
    </Wrapper>
  )
}
export default withTranslations(LastOrderedProducts)

const Wrapper = styled.div``
